import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard as in the original Next.js app
    navigate('/dashboard');
  }, [navigate]);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Welcome to LMS</h1>
      <p className="mb-4">Redirecting to dashboard...</p>
    </div>
  );
};

export default HomePage; 